export default __webpack_public_path__ + "locales/az/JavascriptSdk.json?hash=e450b9c954b8048b7f7de791d24b79ad";